/* eslint-disable react-hooks/exhaustive-deps */
import Axios from 'axios';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { FiChevronDown } from 'react-icons/fi';
import { MdClose } from 'react-icons/md';
import { useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { DIV } from 'src/components/CustomStyledComponents';
import FooterButton from 'src/components/FooterBtn/FooterButton';
import NavbarHeader from 'src/components/header/NavbarHeader';
import LoadingWrapper from 'src/components/Loading/LoadingWrapper';
import withCotizacion from 'src/HOC/withCotizacion';
import useCustomToast from 'src/hooks/useCustomToast';
import useLoading from 'src/hooks/useLoading';
import usePageValidation from 'src/hooks/usePageValidation';
import { imagenSeguro } from 'src/pipes/imagenes';
import { setCotizacion } from 'src/reducers/Cotizacion/cotizacion.actions';
import { guardarLead } from 'src/services';
import { urlGetProudctoById, urlSetProductoCotizacion } from 'src/services/urls';
import { TabView, TabPanel } from 'primereact/tabview';
import ReactPlayer from "react-player";
import { UrlImagenes } from 'src/parametros';
import { Button } from "primereact/button"
import { Accordion, AccordionTab } from 'primereact/accordion';

import UniqueKeyV4 from 'src/components/InputsDinamicos/UniqueKeyV4';
import InputsDinamicos from 'src/components/InputsDinamicos';
import { FormProvider, useForm } from 'react-hook-form';
import { getRandomValues } from 'src/utils/functiones';

const NewPreviewProducto = ({ cotizacion, idCotizacion }) => {
  const [producto, setProducto] = useState<any>({});
  const [show, setModalShow] = useState(false);
  const dispatch = useDispatch();
  const { addWarningToast } = useCustomToast();
  const { values, setLoading, resetLoading, setSecundario } = useLoading();
  const methods = useForm({ mode: 'onChange', shouldUnregister: false });
  const { execEvent, isLoadingCallbacks } = usePageValidation('paginaPreview');

  const [pageProps, setPageProps] = useState<any>({
    footerButton: {
      className: 'btn__footer',
      classNameContainer: 'footer',
      label: 'Adquirir',
    },
    goBack: `/newHome/${idCotizacion}`,
    goTo: `/newRegistro/${idCotizacion}`,
    showBack: true,
    adquirirProducto: true,
  });

  const params = useParams<any>();
  const history = useHistory();

  const init = useCallback(async () => {
    if (!producto.hasOwnProperty('id') && !isLoadingCallbacks) {
      setLoading(true);
      setSecundario('Buscando producto...');
      const body = { id: params.idProducto };
      const { data } = await Axios.post(urlGetProudctoById, JSON.stringify(body));
      if (data.transaccion) {
        setProducto(data?.producto);
        setPageProps({
          labelPrecio: (
            <p className="producto__precio font-weight-bold">
              Adquierelo desde {`$${cotizacion?.producto?.precioMinimoProducto} ${cotizacion?.moneda?.sigla ?? ""}`}
            </p>
          ),
          ...pageProps,
        });
        await execEvent(
          'initCallback',
          {
            pageProps,
            setPageProps,
          });
      }
      resetLoading();
    }
  }, [isLoadingCallbacks, producto]);

  useEffect(() => {
    if (isLoadingCallbacks) {
      return;
    }
    init();
  }, [isLoadingCallbacks]);

  useEffect(() => {
    guardarLead(idCotizacion, `PREVIEW_PRODUCTO__INGRESO`);

  }, []);

  console.log("++pageProps", pageProps)

  const onClickAdquirir = async () => {
    setLoading(true);
    guardarLead(idCotizacion, `PREVIEW_PRODUCTO__CLICK_ADQUIRIR`);
    setSecundario('Buscando información del producto...');

    if (pageProps.adquirirProducto) {
      const body = {
        idCotizacion,
        segCodCore: producto.codigoCore,
      };

      const { data } = await Axios.post(urlSetProductoCotizacion, JSON.stringify(body));

      if (data.transaccion) {
        dispatch(setCotizacion(data.data));
      } else {
        addWarningToast('HA OCURRIDO UN PROBLEMA AL AGREGAR EL PRODUCTO');
      }
    }

    resetLoading();
    return history.push(pageProps.goTo);
  };

  const close = () => {
    setModalShow(false);
  };

  const { coberturas = [], beneficios = [], condiciones = [], exclusiones = [] } = producto


  let cob = []
  if (coberturas.length > 0)
    cob.push({ id: "Coberturas", value: coberturas });
  if (beneficios.length > 0)
    cob.push({ id: "Beneficios", value: beneficios });
  if (condiciones.length > 0)
    cob.push({ id: "Condiciones", value: condiciones });
  if (exclusiones.length > 0)
    cob.push({ id: "Exclusiones", value: exclusiones });


  let esimg = !!producto?.video
  if (esimg) {
    esimg = producto?.video.indexOf('jpg') !== -1 || producto?.video.indexOf('jpeg') !== -1 || producto?.video.indexOf('png') !== -1
  }

  const handleFooter = () => {
    if (producto?.textosInformativos && producto?.textosInformativos.length > 0) setModalShow(true)
    else onClickAdquirir()
  }


  console.log("cob", cob)

  return (
    <LoadingWrapper {...values}>
      <DIV stylePath="preview.globalStyles" className="container-fluid container-page">
        <NavbarHeader showBack={pageProps?.showBack} goBack={pageProps?.goBack} />
        <div className="row justify-content-center mt-5">
          <div className="col-12 col-md-10 col-lg-8 col-xl-7">
            <div className="row justify-content-center">
              <div className="col-3 align-self-center">
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <img className="img-fluid" src={imagenSeguro(producto)} alt={producto?.nombre} style={{ maxHeight: 120 }} />
                </div>
              </div>
              <div className="col-7 align-self-center">
                <h4 className="producto__nombre font-weight-bold">{producto?.nombre}</h4>
                <h6 className="text-justify" >{producto?.descripcion}</h6>
                {cotizacion?.producto?.precioMinimoProducto && pageProps?.labelPrecio}
                {/* {pageProps?.labelPrecio ?? ""} */}
              </div>
            </div>
            <hr />
          </div>
        </div>
        {producto?.video && esimg &&
          <div className="row justify-content-center">
            <div className="col-12 col-md-10 col-lg-8 col-xl-7 ">
              <div style={{ display: "flex", justifyContent: "center" }}>
                <img className="img-fluid" src={`${UrlImagenes}${producto?.video}`} alt="img" />
              </div>

            </div>
          </div>
        }
        {producto?.video && !esimg && (
          <div className="row justify-content-center">
            <div className="col-12 col-md-10 col-lg-8 col-xl-7">
              <div className="img-fluid ratio ratio-16x9">
                <ReactPlayer
                  url={producto?.video}
                  playing={true}
                  width={"100%"}
                  height={"100%"}
                  controls={true}
                />
              </div>
            </div>
          </div>
        )}

        <div className="row justify-content-center" style={{ marginBottom: '5rem' }}>
          <div className="col-12 col-md-10 col-lg-8 col-xl-7  mt-4" >
            <TabView className="tabs-center">
              {cob.map(({ id, value }, i) => <TabPanel key={`tabPre${i}`} header={`${[id]}`} >
                <Extras data={value} />
              </TabPanel>)}
            </TabView>
          </div>
          <div className="col-12" />
          <div className="col-12 col-md-10 col-lg-8 col-xl-7 mt-4">
            <div dangerouslySetInnerHTML={{ __html: cotizacion?.informacion }} />
          </div>
        </div>
        <FooterButton onClick={() => handleFooter()} {...pageProps.footerButton} />
      </DIV>

      <Modal
        show={show}
        onHide={close}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <p>Para continuar debe aceptar las siguientes opciones:</p>
        </Modal.Header>
        <Modal.Body>

          {producto?.textosInformativos && producto?.textosInformativos.length > 0 && (
            <FormProvider {...methods}>
              <form
                className="container__form"
                noValidate
                onSubmit={methods.handleSubmit((data) => {
                  console.log("Click submit", data);
                  onClickAdquirir();
                })}
              >
                <div className="row justify-content-center" >
                  <div className="col-md-12 mt-3">
                      <UniqueKeyV4 />
                      <InputsDinamicos
                        inputs={producto?.textosInformativos}
                      />
                  </div>
                </div>
                <div className="row justify-content-center mt-5" >
                  <Button label="Aceptar" type="submit" />
                </div>
              </form>
            </FormProvider>
          )}
        </Modal.Body>
      </Modal>
    </LoadingWrapper>
  );
};

export default withCotizacion(NewPreviewProducto);

const Extras = ({ data = [] }) => (
  <Accordion >
    {data.map((cobertura) => {
      const llave = `${getRandomValues(4)}`
      return (
        <AccordionTab key={`qwe${llave}`} header={<div className="cobertura__header card-header bg-white border-0">
          <h5 className="cobertura__nombre">{cobertura?.nombre || `${cobertura}`}</h5>
        </div>}>
          {cobertura?.descripcion && (
            <div
              className="cobertura__body card-body text-secondary"
              dangerouslySetInnerHTML={{
                __html: cobertura?.descripcion,
              }}
            />
          )}
        </AccordionTab>
      )
    }
    )}
  </Accordion>
);
